import $ from 'jquery';
import {useState, createRoot} from '@wordpress/element';
import {Modal, Button, Flex, FlexItem, ToggleControl, SelectControl} from '@wordpress/components';

const DEFAULTS = {
    enabled: 'no',
    currency_selector_position: 'above_payment_methods',
};

const toObject = (data) => data.reduce((acc, entry) => {
    acc[entry.key] = entry.value;
    return acc;
}, {});

const AdaptivePricingModal = ({root, data, i18n}) => {
    const [open, setOpen] = useState(true);
    const [processing, setProcessing] = useState(false);
    const [value, setValue] = useState(() => toObject(data));

    const onClose = () => {
        setOpen(false);
        root.unmount();
    };

    const onChange = (key, newValue) => {
        setValue(prev => ({...prev, [key]: newValue}));
        $(document.body).triggerHandler('wc_stripe_adaptive_pricing_config_change', {key, value: newValue});
    };

    const onSave = () => {
        setProcessing(true);
        $(document.body).triggerHandler('wc_stripe_app_settings_save');
    };

    const onReset = () => {
        const resetValues = data.reduce((acc, entry) => {
            acc[entry.key] = entry.default_value || DEFAULTS[entry.key] || '';
            return acc;
        }, {});
        setValue(resetValues);
        $(document.body).triggerHandler('wc_stripe_adaptive_pricing_config_reset');
    };

    if (!open) return null;

    return (
        <Modal
            title={i18n.adaptive_pricing_title || 'Adaptive Pricing'}
            className={'wc-stripe-adaptive-pricing-modal'}
            onRequestClose={onClose}>
            <Flex direction={'column'} gap={4}>
                <FlexItem>
                    <ToggleControl
                        label={i18n.adaptive_pricing_enabled || 'Enabled'}
                        checked={value.enabled === 'yes'}
                        onChange={(checked) => onChange('enabled', checked ? 'yes' : 'no')}
                        help={i18n.adaptive_pricing_enabled_desc}
                    />
                </FlexItem>
                <FlexItem>
                    <SelectControl
                        label={i18n.adaptive_pricing_currency_selector_position || 'Currency Selector Position'}
                        value={value.currency_selector_position || DEFAULTS.currency_selector_position}
                        options={[
                            {
                                label: i18n.adaptive_pricing_position_above || 'Above Payment Methods',
                                value: 'above_payment_methods'
                            },
                            {
                                label: i18n.adaptive_pricing_position_below || 'Below Payment Methods',
                                value: 'below_payment_methods'
                            },
                        ]}
                        onChange={(v) => onChange('currency_selector_position', v)}
                    />
                </FlexItem>
                <FlexItem>
                    <div className={'components-modal__footer'}>
                        <Flex direction={'row'} justify={'flex-end'}>
                            <Button variant={'tertiary'} onClick={onReset}>{i18n.reset}</Button>
                            <Button variant={'secondary'} onClick={onClose}>{i18n.cancel}</Button>
                            <Button
                                variant={'primary'}
                                onClick={onSave}
                                isBusy={processing}
                                disabled={processing}>
                                {i18n.save}
                            </Button>
                        </Flex>
                    </div>
                </FlexItem>
            </Flex>
        </Modal>
    );
};

AdaptivePricingModal.render = (el, {value, i18n}) => {
    if (createRoot) {
        const root = createRoot(el);
        root.render(<AdaptivePricingModal root={root} data={value} i18n={i18n}/>);
    }
};

export default AdaptivePricingModal;